import React, { useEffect, useState } from "react";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { Button, TextField } from "@material-ui/core";
import moment from "moment";
import api from "utils/api";
import APIConstant from "utils/constant";
import cogoToast from "cogo-toast";
import { InputTextarea } from "primereact/inputtextarea";
import { CommonConfig } from "CommonConfig";
import { Checkbox } from "primereact/checkbox";
import { id } from "date-fns/locale";

const SellOutward = (props) => {
  const [userId, setUserId] = useState("");
  const [outwardId, setOutwardId] = useState("");
  const [userPageAccess, setUserPageAccess] = useState([]);
  const [loading, setLoading] = useState(false);
  const [readOnly, setReadOnly] = useState(false);
  const [itemLength, setItemLength] = useState(0);
  const [formData, setFormData] = useState({
    outwardDate: new Date(),
    outwardDateErr: false,
    outwardDateErrText: "",
    orderNo: "",
    orderNoErr: false,
    orderNoErrText: "",
    invoiceNo: "",
    invoiceNoErr: false,
    invoiceNoErrText: "",
    process: "",
    processErr: false,
    processErrText: "",
    processMultiplier: "",
    fromWarehouse: "",
    fromWarehouseErr: false,
    fromWarehouseErrText: "",
    isApplyToAll: false,
    client: "",
    clientErr: false,
    clientErrText: "",
    gstin: "",
    remarks: "",
    totalAmountExcludingGST: "",
    totalAmountIncludingGST: "",
    isGst: false,
    isBatch: false,
  });

  const [itemList, setItemList] = useState([
    {
      itemId: "",
      itemName: "",
      hsnCode: "",
      hsnCodeName: "",
      brandId: "",
      brandName: "",
      gst: "",
      rateExcludingGST: "",
      rateIncludingGST: "",
      quantity: "",
      unit: "",
      unitName: "",
      totalAmountIncludingGST: "",
      mfgDate: "",
      lifeSpan: "",
      expiryDate: "",
      batchNo: "",
      fromWarehouse: "",
      fromWarehouseName: "",
      currentQuantity: "",
      remarks: "",
      barcode: "",
      mrp: 0,
      amount: 0,
      id: "",
    },
  ]);
  const [batchesList, setBatchesList] = useState({});
  const [dropdownData, setDropdownData] = useState({
    process: [],
    warehouse: [],
    client: [],
    product: [],
    hsnCode: [],
    brands: [],
    units: [],
    gstRates: [],
  });

  useEffect(() => {
    let data = localStorage.getItem("Infodata");
    let userPageAccess = localStorage.getItem("PageAccess");
    setUserPageAccess(userPageAccess);
    setUserId(data);

    if (props.location?.state && props.location.state.OutwardId) {
      GetOutwardById(data);
      if (props.location.state.Type === "View") {
        setReadOnly(true);
      } else {
        GetProductMaster(data);
        GetProcessMaster(data);
        GetWarehouseMaster(data);
        GetClientList(data);
        GetUnitMaster(data);
        GetBrandMaster(data);
        GetHSNCodeMaster(data);
        GetGSTMaster(data);
      }
    } else {
      GetProductMaster(data);
      GetProcessMaster(data);
      GetWarehouseMaster(data);
      GetClientList(data);
      GetUnitMaster(data);
      GetBrandMaster(data);
      GetHSNCodeMaster(data);
      GetGSTMaster(data);
    }
  }, []);

  const GetProductMaster = async (UserId) => {
    let params = {
      UserId,
    };
    api
      .post(APIConstant.path.GetVariantList, params)
      .then(async (res) => {
        let response = await res;
        if (response.Success === 1) {
          let filterArry = response.Data.filter((x) => x.UserId != "Admin");
          setDropdownData((prevState) => ({
            ...prevState,
            product: filterArry,
          }));

          let itemBatchList = {};
          filterArry.forEach((product) => {
            itemBatchList[product.value] = product.Variant?.Batches.map(
              (batch) => ({
                ...batch,
                label: batch.BatchNo,
                value: batch._id,
              })
            );
          });
          // console.log({ itemBatchList });
          setBatchesList(itemBatchList);
        }
      })
      .catch((err) => {});
  };

  const GetProcessMaster = async (UserId) => {
    try {
      let params = {
        UserId,
      };
      await api
        .post(APIConstant.path.GetProcessMaster, params)
        .then((response) => {
          if (response.Success === 1) {
            setDropdownData((prevState) => ({
              ...prevState,
              process: response.Data.map((item) => ({
                ...item,
                label: item.ProcessName,
                value: item._id,
              })),
            }));
          }
        })
        .catch((e) => {
          console.log(e);
        });
    } catch (e) {
      console.log(e);
    }
  };

  const GetClientList = async (UserId) => {
    let params = {
      UserId: UserId,
      UserType: "Customer",
    };
    api
      .post(APIConstant.path.GetNetworkByUserType, params)
      .then((response) => {
        if (response.Success === 1) {
          let filterArry = response.Data;
          setDropdownData((prevState) => ({
            ...prevState,
            client: filterArry,
          }));
        }
      })
      .catch(() => {});
  };

  const GetWarehouseMaster = async (UserId) => {
    let params = {
      UserId,
    };
    api
      .post(APIConstant.path.GetSubWareHouseList, params)
      .then(async (res) => {
        let response = await res;
        if (response.Success === 1) {
          let filterArry = response.Data.filter((x) => x.UserId != "Admin").map(
            (item) => ({
              ...item,
              label: item.Name,
              value: item._id,
            })
          );
          setDropdownData((prevState) => ({
            ...prevState,
            warehouse: filterArry,
          }));
        }
      })
      .catch((err) => {});
  };

  const GetUnitMaster = async (UserId) => {
    let params = {
      UserId,
    };
    api
      .post(APIConstant.path.GetUnitMaster, params)
      .then(async (res) => {
        let response = await res;
        if (response.Success === 1) {
          let filterArry = response.Data.filter((x) => x.UserId != "Admin");
          setDropdownData((prevState) => ({
            ...prevState,
            units: filterArry,
          }));
        }
      })
      .catch((err) => {});
  };

  const GetBrandMaster = async (UserId) => {
    let params = {
      UserId: UserId,
    };
    api
      .post(APIConstant.path.GetBrandMaster, params)
      .then((response) => {
        if (response.Success === 1) {
          let filterArry = response.Data.filter((x) => x.UserId != "Admin");
          setDropdownData((prevState) => ({
            ...prevState,
            brands: filterArry,
          }));
        }
      })
      .catch((err) => {});
  };

  const GetHSNCodeMaster = async (UserId) => {
    let params = {
      UserId: UserId,
    };
    api
      .post(APIConstant.path.GetHSNCodeMaster, params)
      .then((response) => {
        if (response.Success === 1) {
          let filterArry = response.Data.filter((x) => x.UserId != "Admin");

          setDropdownData((prevState) => ({
            ...prevState,
            hsnCode: filterArry,
          }));
        }
      })
      .catch((err) => {});
  };

  const GetGSTMaster = async (UserId) => {
    let params = {
      UserId: UserId,
      Type: "GST",
    };
    api
      .post(APIConstant.path.GetMasterListByType, params)
      .then((response) => {
        if (response.Success === 1) {
          let filterArry = response.Data.filter((x) => x.UserId != "Admin").map(
            (data) => ({
              label: data.name,
              value: data.value,
            })
          );

          setDropdownData((prevState) => ({
            ...prevState,
            gstRates: filterArry,
          }));
        }
      })
      .catch((err) => {});
  };

  const GetOutwardById = async (UserId) => {
    try {
      let params = {
        UserId,
        OutwardId: props.location.state.OutwardId,
      };
      api
        .post(APIConstant.path.GetOutwardById, params)
        .then((response) => {
          if (response.Success === 1) {
            const {
              OutwardDate,
              OrderNo,
              InvoiceNo,
              Process,
              ProcessName,
              ProcessMultiplier,
              FromWarehouse,
              FromWarehouseName,
              IsApplyToAll,
              Client,
              ClientName,
              GSTIN,
              Remarks,
              TotalAmountExcludingGST,
              TotalAmountIncludingGST,
              ItemList,
              _id,
              IsGst,
              IsBatch,
              TotalMRP,
              ClientId,
            } = response.Data;
            setFormData((prevState) => ({
              ...prevState,
              outwardDate: OutwardDate,
              orderNo: OrderNo,
              invoiceNo: InvoiceNo,
              process: Process,
              processName: ProcessName,
              processMultiplier: ProcessMultiplier,
              fromWarehouse: FromWarehouse,
              fromWarehouseName: FromWarehouseName,
              isApplyToAll: IsApplyToAll,
              client: ClientId,
              clientName: ClientName,
              gstin: GSTIN,
              remarks: Remarks,
              totalAmountExcludingGST: TotalAmountExcludingGST,
              totalAmountIncludingGST: TotalAmountIncludingGST,
              isBatch: IsBatch,
              isGst: IsGst,
              TotalMRP: TotalMRP,
            }));
            let tempItemList = ItemList.map((item) => ({
              itemId: item.ItemId,
              itemName: item.ItemName,
              hsnCode: item.HSNCode,
              hsnCodeName: item.HSNCodeName,
              brandId: item.Brand,
              brandName: item.BrandName,
              gst: item.GST,
              rateExcludingGST: item.RateExcludingGST,
              rateIncludingGST: item.RateIncludingGST,
              quantity: item.Quantity,
              originalUnit: item.OriginalUnitId,
              unit: item.UnitId,
              unitName: item.UnitName,
              totalAmountIncludingGST: item.TotalAmountIncludingGST,
              mfgDate: item.MfgDate,
              lifeSpan: item.LifeSpan,
              expiryDate: item.ExpiryDate,
              // batchNoList: dropdownData.product
              //   .find((item) => item._id === item.ItemId)
              //   ?.Variant?.Batches.map((batch) => ({
              //     ...batch,
              //     label: batch.BatchNo,
              //     value: batch._id,
              //   })),
              batchNo: item.BatchNoId,
              batchNoName: item.BatchNo,
              fromWarehouse: item.FromWarehouse,
              fromWarehouseName: item.FromWarehouseName,
              currentQuantity: item.CurrentQuantity,
              remarks: item.Remarks,
              barcode: item.Barcode,
              mrp: item.MRP,
              amount: item.Amount,
              id: item?._id,
            }));
            setOutwardId(_id);
            setItemList(tempItemList);
            setItemLength(ItemList.length);
          } else {
            // console.log(response.Message);
          }
        })
        .catch((err) => {});
    } catch (e) {
      console.log(e);
    }
  };

  const AddOutward = async (type) => {
    setLoading(true);

    if (!validate()) return setLoading(false);

    try {
      const payload = {
        OutwardDate: formData.outwardDate,
        OutwardType: "Sell",
        SellType: type || null,
        OrderId: formData.orderId,
        OrderNo: formData.orderNo,
        InvoiceNo: formData.invoiceNo,
        Process: formData.process,
        ProcessName: dropdownData.process.find(
          (item) => item.value === formData.process
        )?.label,
        ProcessMultiplier: formData.processMultiplier,
        FromWarehouse: formData.fromWarehouse,
        FromWarehouseName: dropdownData.warehouse.find(
          (item) => item.value === formData.fromWarehouse
        )?.label,
        IsApplyToAll: formData.isApplyToAll,
        Client: formData.client,
        ClientName: dropdownData.client.find(
          (item) => item.value === formData.client
        )?.label,
        GSTIN: formData.gstin,
        Remarks: formData.remarks,
        TotalAmountExcludingGST: formData.totalAmountExcludingGST,
        TotalAmountIncludingGST: formData.totalAmountIncludingGST,
        ItemList: itemList.map((item) => {
          return {
            ItemId: item.itemId,
            ItemName: dropdownData.product.find(
              (obj) => obj.value === item.itemId
            )?.label,
            HSNCode: item.hsnCode,
            HSNCodeName: dropdownData.hsnCode.find(
              (obj) => obj.value === item.hsnCode
            )?.label,
            Brand: item.brandId,
            BrandName: dropdownData.brands.find(
              (obj) => obj.value === item.brandId
            )?.label,
            RateExcludingGST: item.rateExcludingGST,
            GST: item.gst,
            GSTName: dropdownData.gstRates.find((obj) => obj.value === item.gst)
              ?.label,
            RateIncludingGST: item.rateIncludingGST,
            Quantity: item.quantity,
            UnitId: item.unit,
            UnitName: dropdownData.units.find((obj) => obj.value === item.unit)
              ?.label,
            OriginalUnitId: item.originalUnit,
            TotalAmountIncludingGST: item.totalAmountIncludingGST,
            TotalAmountIncludingGST: item.totalAmountIncludingGST,
            MfgDate: item.mfgDate,
            LifeSpan: item.lifeSpan,
            ExpiryDate: item.expiryDate,
            BatchNoId: item.batchNo,
            BatchNo: batchesList[item.itemId]?.find(
              (obj) => obj.value === item.batchNo
            )?.label,
            FromWarehouse: item.fromWarehouse,
            FromWarehouseName: dropdownData.warehouse.find(
              (dropdownItem) => dropdownItem.value === item.fromWarehouse
            )?.label,
            CurrentQuantity: item.currentQuantity,
            Remarks: item.remarks,
            Barcode: item.barcode,
            MRP: item.mrp,
            Amount: item.amount,
            id: item.id,
          };
        }),
        UserId: userId,
        OutwardId: outwardId,
        IsGst: formData?.isGst,
        IsBatch: formData?.isBatch,
        TotalMRP: itemList?.length
          ? itemList?.reduce((a, b) => Number(a) + Number(b.mrp), 0) *
            itemList?.reduce((a, b) => Number(a) + Number(b.quantity), 0)
          : 0.0,
        TotalAmount: itemList?.length
          ? itemList?.reduce((a, b) => Number(a) + Number(b.quantity), 0) *
            itemList?.reduce((a, b) => Number(a) + Number(b.amount), 0)
          : 0.0,
      };

      api.post(APIConstant.path.AddUpdateOutward, payload).then((res) => {
        if (res.Success == 1) {
          setLoading(false);
          cogoToast.success(res.Message);
          props.history.push("/admin/outward");
        } else {
          setLoading(false);
          cogoToast.error(res.Message);
        }
      });
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const GetVariantByBarcode = async (Barcode, index) => {
    let params = { UserId: userId, Barcode };
    api
      .post(APIConstant.path.GetVariantByBarcode, params)
      .then((response) => {
        if (response.Success === 1) {
          setItemList((prev) => {
            const updated = [...prev];
            let itemData = response.Data;

            updated[index].itemId = itemData.value;
            updated[index].hsnCode = itemData.HSNCode;
            updated[index].gst = itemData.GstRate;
            updated[index].brandId = itemData.Brand;
            updated[index].unit = itemData.UnitId;
            updated[index].originalUnit = itemData.UnitId;
            updated[index].lifeSpan = itemData.LifeSpan;
            updated[index].amount = itemData.amount;
            if (itemData.Variant) {
              updated[index].mrp = itemData.Variant.Mrp;
              updated[index].rateExcludingGST = itemData.Variant.Price;
              updated[index].rateIncludingGST = itemData.Variant.Price
                ? itemData.Variant.Price +
                  (itemData.Variant.Price * itemData.GstRate) / 100
                : "";
            }

            if (formData.isBatch && itemData.Batch) {
              let tempBatch = itemData.Batch;
              if (tempBatch) {
                updated[index].batchNo = tempBatch._id;
                updated[index].mfgDate = tempBatch.MfgDate;
                updated[index].expiryDate = tempBatch.ExpiryDate;
              }
            }

            return updated;
          });
        } else {
          cogoToast.error(response.Message);
        }
      })
      .catch(() => {});
  };

  const validate = () => {
    let isValid = true;

    let updatedFormData = { ...formData };

    const formFieldsToValidate = [
      { key: "outwardDate", label: "Date" },
      { key: "orderNo", label: "Order No" },
      { key: "invoiceNo", label: "Invoice No" },
      // { key: "process", label: "Process" },
      { key: "fromWarehouse", label: "Warehouse" },
      { key: "client", label: "Client" },
    ];

    formFieldsToValidate.forEach(({ key, label }) => {
      if (CommonConfig.isEmpty(updatedFormData[key])) {
        isValid = false;
        updatedFormData[`${key}Err`] = true;
        updatedFormData[`${key}ErrText`] = `${label} is required`;
      } else {
        updatedFormData[`${key}Err`] = false;
        updatedFormData[`${key}ErrText`] = "";
      }
    });

    setFormData(updatedFormData);

    let tempItems = [...itemList];

    tempItems = tempItems.map((item) => {
      const updatedItem = { ...item };

      const itemFields = [
        { key: "itemId", label: "Item" },
        // { key: "hsnCode", label: "HSNCode" },
        { key: "unit", label: "Unit" },
        // { key: "batchNo", label: "Batch No" },
        { key: "fromWarehouse", label: "Warehouse" },
      ];

      itemFields.forEach(({ key, label }) => {
        if (CommonConfig.isEmpty(item[key])) {
          isValid = false;
          updatedItem[`${key}Err`] = true;
          updatedItem[`${key}ErrText`] = `${label} is required`;
        } else {
          updatedItem[`${key}Err`] = false;
          updatedItem[`${key}ErrText`] = "";
        }
      });

      return updatedItem;
    });

    setItemList(tempItems);

    if (!itemList.length) {
      isValid = false;
      cogoToast.error("Please select items");
    }

    return isValid;
  };

  const handleFormChange = (value, field, regex) => {
    if (!value) {
      if (field === "lifeSpan") {
        let tempItems = [...itemList];
        tempItems.forEach((item) => {
          item.Batches.forEach((batch) => {
            batch.expiryDate = "";
          });
        });
        setItemList(tempItems);
      }
      setFormData((prev) => ({
        ...prev,
        [field]: "",
        [`${field}Err`]: true,
        [`${field}ErrText`]: `This field is required`,
      }));
    } else {
      if (!regex || regex.test(value)) {
        let extraObj = {};
        if (field === "hsnCode") {
          extraObj.gstRate = dropdownData.hsnCodes.find(
            (item) => item.value === value
          )?.GST;
        } else if (field === "subCategory") {
          extraObj.category = dropdownData.subCategories.find(
            (item) => item.value === value
          )?.Category;
        } else if (field === "lifeSpan") {
          let tempItems = [...itemList];
          tempItems.forEach((item, varIdx) => {
            item.Batches.forEach((batch, batchIdx) => {
              if (batch.mfgDate) {
                batch.expiryDate = moment(batch.mfgDate)
                  .add(parseInt(value), "days")
                  .toDate();
              }
            });
          });
          setItemList(tempItems);
        } else if (field === "isApplyToAll") {
          if (value && formData.fromWarehouse) {
            let tempItemList = [...itemList];
            tempItemList.forEach((item) => {
              item.fromWarehouse = formData.fromWarehouse;
            });
            setItemList(tempItemList);
          }
        } else if (field === "fromWarehouse") {
          if (value && formData.isApplyToAll) {
            let tempItemList = [...itemList];
            tempItemList.forEach((item) => {
              item.fromWarehouse = value;
            });
            setItemList(tempItemList);
          }
        }
        setFormData((prev) => ({
          ...prev,
          [field]: value,
          [`${field}Err`]: false,
          [`${field}ErrText`]: "",
          ...extraObj,
        }));
      }
    }
  };

  const handleItemListChange = (value, field, index, regex) => {
    if (!value) {
      setItemList((prev) => {
        const updated = [...prev];
        updated[index][field] = value;
        updated[index][`${field}Err`] = true;
        updated[index][`${field}ErrText`] = `This field is required`;
        if (field === "lifeSpan") {
          updated[index].expiryDate = "";
        }
        return updated;
      });
    } else {
      if (!regex || regex.test(value)) {
        setItemList((prev) => {
          const updated = [...prev];
          if (field === "barcode") {
            value = value.toUpperCase();
          }
          updated[index][field] = value;
          updated[index][`${field}Err`] = false;
          updated[index][`${field}ErrText`] = "";

          if (field === "itemId") {
            let itemData = dropdownData.product.find(
              (item) => item.value === value
            );
            if (itemData) {
              updated[index].hsnCode = itemData.HSNCode;
              updated[index].gst = itemData.GstRate;
              updated[index].brandId = itemData.Brand;
              updated[index].unit = itemData.UnitId;
              updated[index].originalUnit = itemData.UnitId;
              updated[index].lifeSpan = itemData.LifeSpan;
              if (itemData.Variant) {
                updated[index].rateExcludingGST = itemData.Variant.Price;
                updated[index].rateIncludingGST = itemData.Variant.Price
                  ? itemData.Variant.Price +
                    (itemData.Variant.Price * itemData.GstRate) / 100
                  : "";
                // updated[index].batchNoList = itemData.Variant.Batches.map(
                //   (batch) => ({
                //     ...batch,
                //     label: batch.BatchNo,
                //     value: batch._id,
                //   })
                // );
              }
            }
          } else if (field === "batchNo") {
            let tempBatch = batchesList[updated[index].itemId]?.find(
              (batch) => batch.value === value
            );
            if (tempBatch) {
              updated[index].mfgDate = tempBatch.MfgDate;
              updated[index].expiryDate = tempBatch.ExpiryDate;
            }
          } else if (field === "lifeSpan") {
            if (updated[index].mfgDate) {
              updated[index].expiryDate = moment(updated[index].mfgDate)
                .add(parseInt(value), "days")
                .toDate();
            }
          }
          return updated;
        });
      }
    }
  };

  const handleKeyDown = (e, idx) => {
    if (e.key === "Enter") {
      try {
        if (itemList[idx].barcode) {
          GetVariantByBarcode(itemList[idx].barcode, idx);
        }
      } catch (err) {
        console.log(err);
      }
    }
  };

  const addItem = () => {
    setItemLength((prev) => prev + 1);
    setItemList((prev) => [
      ...prev,
      {
        itemId: "",
        itemName: "",
        hsnCode: "",
        hsnCodeName: "",
        brandId: "",
        brandName: "",
        gst: "",
        rateExcludingGST: "",
        rateIncludingGST: "",
        quantity: "",
        unit: "",
        unitName: "",
        totalAmountIncludingGST: "",
        mfgDate: "",
        lifeSpan: "",
        expiryDate: "",
        batchNo: "",
        fromWarehouse: "",
        fromWarehouseName: "",
        currentQuantity: "",
        remarks: "",
        barcode: "",
        mrp: 0,
        amount: 0,
        id: "",
        // batchNoList: [],
      },
    ]);
  };

  const removeItem = (index) => {
    setItemList((prev) => prev.filter((_, i) => i !== index));
  };

  return (
    <>
      <div className="container-body e-container-body">
        <div className="conatiner-tab-body p-mt-3 p-mx-1 e-view-card">
          <div className="p-grid">
            <div className="p-sm-12 p-md-3 p-mt-1">
              <div className="p-d-flex p-ai-center p-mt-4">
                <div className="flex align-items-center">
                  <Checkbox
                    inputId="apply"
                    name="isGst"
                    onChange={(e) => handleFormChange(e.checked, "isGst")}
                    checked={formData.isGst}
                  />
                  <label htmlFor="apply" className="p-ml-2">
                    GST
                  </label>
                </div>

                <div className="p-d-flex p-ai-center p-ml-3">
                  <Checkbox
                    inputId="apply"
                    name="isBatch"
                    onChange={(e) => handleFormChange(e.checked, "isBatch")}
                    checked={formData.isBatch}
                  />
                  <label htmlFor="apply" className="p-ml-2">
                    BATCH
                  </label>
                </div>
              </div>
            </div>
            <div className="p-sm-12 p-md-3">
              <div className="p-w-100 ">
                <div className="custom-inputs e-order-mng order">
                  <p className="text p-mb-1">Outward Date</p>
                  {readOnly ? (
                    <p className="sub-text">
                      {formData.outwardDate
                        ? moment(formData.outwardDate).format("DD/MM/YYYY")
                        : ""}
                    </p>
                  ) : (
                    <>
                      <div>
                        <Calendar
                          value={
                            formData.outwardDate
                              ? new Date(formData.outwardDate)
                              : null
                          }
                          onChange={(e) =>
                            handleFormChange(e.value, "outwardDate")
                          }
                          dateFormat="dd/mm/yy"
                          showIcon={false}
                          placeholder="Select Date"
                          className="p-w-100"
                          autoFocus
                        />
                      </div>
                      <span className="error-msg" style={{ color: "red" }}>
                        {formData.outwardDateErr
                          ? formData.outwardDateErrText
                          : null}
                      </span>
                    </>
                  )}
                </div>
              </div>
            </div>
            <div className="p-sm-12 p-md-3">
              <div className="p-w-100 ">
                <div className="custom-inputs e-order-mng order">
                  <p className="text p-mb-1">Order No</p>
                  {readOnly ? (
                    <p className="sub-text">{formData.orderNo}</p>
                  ) : (
                    <>
                      <div>
                        <InputText
                          value={formData.orderNo}
                          onChange={(e) =>
                            handleFormChange(e.target.value, "orderNo")
                          }
                          maxLength={5}
                          placeholder="Order No"
                          className="p-w-100 e-input-common"
                        />
                      </div>
                      <span className="error-msg" style={{ color: "red" }}>
                        {formData.orderNoErr ? formData.orderNoErrText : null}{" "}
                      </span>
                    </>
                  )}
                </div>
              </div>
            </div>
            <div className="p-sm-12 p-md-3">
              <div className="p-w-100 ">
                <div className="custom-inputs e-order-mng order">
                  <p className="text p-mb-1">Invoice No</p>
                  {readOnly ? (
                    <p className="sub-text">{formData.invoiceNo}</p>
                  ) : (
                    <>
                      <div>
                        <InputText
                          value={formData.invoiceNo}
                          onChange={(e) =>
                            handleFormChange(e.target.value, "invoiceNo")
                          }
                          maxLength={5}
                          placeholder="Invoice No"
                          className="p-w-100 e-input-common"
                        />
                      </div>
                      <span className="error-msg" style={{ color: "red" }}>
                        {formData.invoiceNoErr
                          ? formData.invoiceNoErrText
                          : null}{" "}
                      </span>
                    </>
                  )}
                </div>
              </div>
            </div>
            {/* <div className="p-sm-12 p-md-3">
              <div className="p-w-100 ">
                <div className="custom-inputs e-order-mng order">
                  <p className="text p-mb-1">Process</p>
                  {readOnly ? (
                    <p className="sub-text">{formData.processName}</p>
                  ) : (
                    <>
                      <div>
                        <Dropdown
                          filter
                          options={dropdownData.process}
                          value={formData.process}
                          onChange={(e) => handleFormChange(e.value, "process")}
                          placeholder="process"
                          className="p-w-100"
                        />
                      </div>
                      <span className="error-msg" style={{ color: "red" }}>
                        {formData.processErr ? formData.processErrText : null}{" "}
                      </span>
                    </>
                  )}
                </div>
              </div>
            </div> */}
            {/* <div className="p-sm-12 p-md-3">
              <div className="p-w-100 ">
                <div className="custom-inputs e-order-mng order">
                  <p className="text p-mb-1">Process Multiplier</p>
                  {readOnly ? (
                    <p className="sub-text">{formData.processMultiplier}</p>
                  ) : (
                    <>
                      <div>
                        <InputText
                          value={formData.processMultiplier}
                          onChange={(e) =>
                            handleFormChange(
                              e.target.value,
                              "processMultiplier",
                              /^\d*$/i
                            )
                          }
                          maxLength={5}
                          placeholder="Enter Value"
                          className="p-w-100 e-input-common"
                        />
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div> */}
            <div className="p-sm-12 p-md-3">
              <div className="p-w-100 ">
                <div className="custom-inputs e-order-mng order">
                  <p className="text p-mb-1">From Warehouse</p>
                  {readOnly ? (
                    <p className="sub-text">{formData.fromWarehouseName}</p>
                  ) : (
                    <>
                      <div>
                        <Dropdown
                          filter
                          options={dropdownData.warehouse}
                          value={formData.fromWarehouse}
                          onChange={(e) =>
                            handleFormChange(e.value, "fromWarehouse")
                          }
                          placeholder="Warehouse"
                          className="p-w-100"
                        />
                      </div>
                      <span className="error-msg" style={{ color: "red" }}>
                        {formData.fromWarehouseErr
                          ? formData.fromWarehouseErrText
                          : null}
                      </span>
                    </>
                  )}
                </div>
              </div>
            </div>
            <div className="p-sm-12 p-md-3">
              <div className="flex align-items-center p-mt-5">
                <Checkbox
                  inputId="apply"
                  name="isApplyToAll"
                  onChange={(e) => handleFormChange(e.checked, "isApplyToAll")}
                  checked={formData.isApplyToAll}
                />
                <label htmlFor="apply" className="p-ml-2">
                  Apply this warehouse to all
                </label>
              </div>
            </div>
            {/* <div className="p-sm-12 p-md-3">
              <div className="p-w-100 ">
                <div className="custom-inputs e-order-mng order">
                  <p className="text p-mb-1">Life Span (Days)</p>
                  {readOnly ? (
                    <p className="sub-text">{formData.lifeSpan}</p>
                  ) : (
                    <>
                      <div>
                        <InputText
                          value={formData.lifeSpan}
                          onChange={(e) =>
                            handleFormChange(
                              e.target.value,
                              "lifeSpan",
                              /^\d*$/i
                            )
                          }
                          maxLength={5}
                          placeholder="Life Span"
                        />
                      </div>
                      <span className="error-msg" style={{ color: "red" }}>
                        {formData.lifeSpanErr ? formData.lifeSpanErrText : null}{" "}
                      </span>
                    </>
                  )}
                </div>
              </div>
            </div> */}
            <div className="p-sm-12 p-md-3">
              <div className="p-w-100 ">
                <div className="custom-inputs e-order-mng order">
                  <p className="text p-mb-1">Client Name</p>
                  {readOnly ? (
                    <p className="sub-text">{formData.clientName}</p>
                  ) : (
                    <>
                      <div>
                        <Dropdown
                          filter
                          options={dropdownData.client}
                          value={formData.client}
                          onChange={(e) => handleFormChange(e.value, "client")}
                          placeholder="Client"
                          className="p-w-100"
                        />
                      </div>
                      <span className="error-msg" style={{ color: "red" }}>
                        {formData.clientErr ? formData.clientErrText : null}{" "}
                      </span>
                    </>
                  )}
                </div>
              </div>
            </div>
            {formData.isGst ? (
              <div className="p-sm-12 p-md-3">
                <div className="p-w-100 ">
                  <div className="custom-inputs e-order-mng order">
                    <p className="text p-mb-1">GSTIN</p>
                    {readOnly ? (
                      <p className="sub-text">{formData.gstin}</p>
                    ) : (
                      <>
                        <div>
                          <InputText
                            value={formData.gstin}
                            onChange={(e) =>
                              handleFormChange(e.target.value, "gstin")
                            }
                            maxLength={5}
                            placeholder="GST"
                            className="p-w-100 e-input-common"
                          />
                        </div>

                        {/* <div>
                        <Dropdown
                          options={dropdownData.gstRates}
                          value={formData.gstin}
                          onChange={(e) => handleFormChange(e.value, "gstin")}
                          placeholder="GST"
                        />
                      </div> */}
                      </>
                    )}
                  </div>
                </div>
              </div>
            ) : null}
            <div className="p-sm-12 p-md-3">
              <div className="p-w-100 ">
                <div className="custom-inputs e-order-mng order">
                  {/* <p className="text p-mb-1">Total Amt (Excl. GST)</p> */}
                  <p className="text p-mb-1">
                    {formData.isGst ? "Total Amt (Excl. GST)" : "Total Amt"}
                  </p>
                  {readOnly ? (
                    <p className="sub-text">
                      {formData.isGst
                        ? formData.totalAmountExcludingGST
                        : itemList?.length
                        ? itemList?.reduce(
                            (a, b) => Number(a) + Number(b.rateExcludingGST),
                            0
                          ) *
                          itemList?.reduce(
                            (a, b) => Number(a) + Number(b.quantity),
                            0
                          )
                        : 0.0}
                    </p>
                  ) : (
                    <>
                      <div>
                        <InputText
                          value={
                            formData.isGst
                              ? formData.totalAmountExcludingGST
                              : itemList?.length
                              ? itemList?.reduce(
                                  (a, b) =>
                                    Number(a) + Number(b.rateExcludingGST),
                                  0
                                ) *
                                itemList?.reduce(
                                  (a, b) => Number(a) + Number(b.quantity),
                                  0
                                )
                              : 0.0
                          }
                          onChange={(e) =>
                            handleFormChange(
                              e.target.value,
                              "totalAmountExcludingGST",
                              /^\d+(\.\d{0,2})?$/i
                            )
                          }
                          maxLength={10}
                          placeholder="Amount excluding GST"
                          className="p-w-100 e-input-common"
                        />
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
            {formData.isGst ? (
              <div className="p-sm-12 p-md-3">
                <div className="p-w-100 ">
                  <div className="custom-inputs e-order-mng order">
                    <p className="text p-mb-1">Total Amt (Incl. GST)</p>
                    {readOnly ? (
                      <p className="sub-text">
                        {formData.totalAmountIncludingGST}
                      </p>
                    ) : (
                      <>
                        <div>
                          <InputText
                            value={formData.totalAmountIncludingGST}
                            onChange={(e) =>
                              handleFormChange(
                                e.target.value,
                                "totalAmountIncludingGST",
                                /^\d+(\.\d{0,2})?$/i
                              )
                            }
                            maxLength={10}
                            placeholder="Amount including GST"
                            className="p-w-100 e-input-common"
                          />
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            ) : null}

            <div className="p-sm-12 p-md-3">
              <div className="p-w-100 ">
                <div className="custom-inputs e-order-mng order">
                  <p className="text p-mb-1">Total MRP</p>
                  {readOnly ? (
                    <p className="sub-text">
                      {itemList?.length
                        ? itemList?.reduce(
                            (a, b) => Number(a) + Number(b.mrp),
                            0
                          ) *
                          itemList?.reduce(
                            (a, b) => Number(a) + Number(b.quantity),
                            0
                          )
                        : 0.0}
                    </p>
                  ) : (
                    <InputText
                      disabled
                      className="p-w-100"
                      value={
                        itemList?.length
                          ? itemList?.reduce(
                              (a, b) => Number(a) + Number(b.mrp),
                              0
                            ) *
                            itemList?.reduce(
                              (a, b) => Number(a) + Number(b.quantity),
                              0
                            )
                          : 0.0
                      }
                      onChange={(e) =>
                        handleFormChange(e.target.value, "totalMRP")
                      }
                      maxLength={200}
                      placeholder="Total MRP"
                    />
                  )}
                </div>
              </div>
            </div>
            <div className="p-sm-12">
              <div className="p-w-100 ">
                <div className="custom-inputs e-order-mng order">
                  <p className="text p-mb-1">Remarks</p>
                  {readOnly ? (
                    <p className="sub-text">{formData.remarks}</p>
                  ) : (
                    <InputTextarea
                      className="p-w-100"
                      value={formData.remarks}
                      onChange={(e) =>
                        handleFormChange(e.target.value, "remarks")
                      }
                      maxLength={200}
                      placeholder="Remarks"
                    />
                  )}
                </div>
              </div>
            </div>
          </div>

          {itemList?.map((item, vIdx) => (
            <div
              key={vIdx}
              className="item-section p-mb-3"
              style={{
                background: "#fff",
                borderRadius: "8px",
                border: "2px dotted #bdbdbd",
                width: "100%",
                marginBottom: "12px",
                position: "relative",
                boxSizing: "border-box",
                transition: "border 0.2s",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  background: "#f5f5f5",
                  borderRadius: "8px",
                  padding: "12px 20px",
                  marginBottom: "18px",
                  minHeight: "48px",
                }}
              >
                <span
                  style={{
                    fontWeight: "600",
                    color: "#09090B",
                    fontSize: "1rem",
                    letterSpacing: "0.5px",
                  }}
                >
                  Item {vIdx + 1}
                </span>
                {!readOnly && (
                  <Button
                    variant="outlined"
                    color="secondary"
                    onClick={() => removeItem(vIdx)}
                    style={{
                      minWidth: 120,
                      borderRadius: 8,
                      fontWeight: 500,
                      boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
                      background: "#fff",
                    }}
                  >
                    <i className="pi pi-trash" style={{ marginRight: 8 }}></i>{" "}
                    Delete Item
                  </Button>
                )}
              </div>
              <div className="p-grid p-px-4">
                <div className="p-sm-12 p-md-3">
                  <div className="p-w-100 ">
                    <div className="custom-inputs e-order-mng order">
                      <p className="text p-mb-1">Raw Material/Item</p>
                      {readOnly ? (
                        <p className="sub-text">{item.itemName}</p>
                      ) : (
                        <>
                          <div>
                            <Dropdown
                              filter
                              options={dropdownData.product}
                              value={item.itemId}
                              onChange={(e) =>
                                handleItemListChange(e.value, "itemId", vIdx)
                              }
                              placeholder="Item"
                              className="p-w-100 e-input-common"
                            />
                          </div>
                          <span className="error-msg" style={{ color: "red" }}>
                            {item.itemErr ? item.itemErrText : null}{" "}
                          </span>
                        </>
                      )}
                    </div>
                  </div>
                </div>
                <div className="p-sm-12 p-md-3">
                  <div className="p-w-100 ">
                    <div className="custom-inputs e-order-mng order">
                      <p className="text p-mb-1">Barcode</p>
                      {readOnly ? (
                        <p className="sub-text">{item.barcode}</p>
                      ) : (
                        <InputText
                          value={item.barcode}
                          onChange={(e) =>
                            handleItemListChange(
                              e.target.value,
                              "barcode",
                              vIdx
                            )
                          }
                          maxLength={50}
                          onKeyDown={(e) => handleKeyDown(e, vIdx)}
                          placeholder="Barcode"
                          className="p-w-100 e-input-common"
                        />
                      )}
                    </div>
                  </div>
                </div>
                {formData.isGst ? (
                  <div className="p-sm-12 p-md-3">
                    <div className="p-w-100 ">
                      <div className="custom-inputs e-order-mng order">
                        <p className="text p-mb-1">HSN Code</p>
                        {readOnly ? (
                          <p className="sub-text">{item.hsnCodeName}</p>
                        ) : (
                          <>
                            <div>
                              <Dropdown
                                filter
                                options={dropdownData.hsnCode}
                                value={item.hsnCode}
                                onChange={(e) =>
                                  handleItemListChange(e.value, "hsnCode", vIdx)
                                }
                                placeholder="HSN Code"
                                className="p-w-100 e-input-common"
                              />
                            </div>
                            <span
                              className="error-msg"
                              style={{ color: "red" }}
                            >
                              {item.hsnCodeErr ? item.hsnCodeErrText : null}
                            </span>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                ) : null}
                <div className="p-sm-12 p-md-3">
                  <div className="p-w-100 ">
                    <div className="custom-inputs e-order-mng order">
                      <p className="text p-mb-1">Brand Name</p>
                      {readOnly ? (
                        <p className="sub-text">{item.brandName}</p>
                      ) : (
                        <>
                          <div>
                            <Dropdown
                              filter
                              options={dropdownData.brands}
                              value={item.brandId}
                              onChange={(e) =>
                                handleItemListChange(e.value, "brandId", vIdx)
                              }
                              placeholder="Brand Name"
                              className="p-w-100 e-input-common"
                            />
                          </div>
                          <span className="error-msg" style={{ color: "red" }}>
                            {item.brandErr ? item.brandErrText : null}
                          </span>
                        </>
                      )}
                    </div>
                  </div>
                </div>
                <div className="p-sm-12 p-md-3">
                  <div className="p-w-100 ">
                    <div className="custom-inputs e-order-mng order">
                      <p className="text p-mb-1">
                        {formData.isGst ? "Rate (Excl. of GST)" : "Rate"}
                      </p>
                      {readOnly ? (
                        <p className="sub-text">
                          {formData.isGst
                            ? formData.totalAmountExcludingGST
                            : itemList?.length
                            ? Number(
                                itemList?.reduce(
                                  (a, b) =>
                                    Number(a) + Number(b.rateExcludingGST),
                                  0
                                )
                              ) *
                              Number(
                                itemList?.reduce(
                                  (a, b) => Number(a) + Number(b.quantity),
                                  0
                                )
                              )
                            : 0.0}
                        </p>
                      ) : (
                        <>
                          <div>
                            <InputText
                              value={
                                formData.isGst
                                  ? formData.totalAmountExcludingGST
                                  : itemList?.length
                                  ? Number(
                                      itemList?.reduce(
                                        (a, b) =>
                                          Number(a) +
                                          Number(b.rateExcludingGST),
                                        0
                                      )
                                    ) *
                                    Number(
                                      itemList?.reduce(
                                        (a, b) =>
                                          Number(a) + Number(b.quantity),
                                        0
                                      )
                                    )
                                  : 0.0
                              }
                              onChange={(e) =>
                                handleItemListChange(
                                  e.target.value,
                                  "rateExcludingGST",
                                  vIdx,
                                  /^\d+(\.\d{0,2})?$/i
                                )
                              }
                              maxLength={15}
                              placeholder="Rate"
                              className="p-w-100 e-input-common"
                            />
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
                {formData.isGst ? (
                  <>
                    <div className="p-sm-12 p-md-3">
                      <div className="p-w-100 ">
                        <div className="custom-inputs e-order-mng order">
                          <p className="text p-mb-1">GST %</p>
                          {readOnly ? (
                            <p className="sub-text">{item.gst}</p>
                          ) : (
                            <>
                              {/* <div>
                            <InputText
                              value={item.gst}
                              onChange={(e) =>
                                handleItemListChange(
                                  e.target.value,
                                  "gst",
                                  vIdx,
                                  /^\d*$/i
                                )
                              }
                              maxLength={15}
                              placeholder="Rate"
                            />
                          </div> */}

                              <div>
                                <Dropdown
                                  filter
                                  options={dropdownData.gstRates}
                                  value={item.gst}
                                  onChange={(e) =>
                                    handleItemListChange(e.value, "gst", vIdx)
                                  }
                                  placeholder="GST"
                                  className="p-w-100 e-input-common"
                                />
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="p-sm-12 p-md-3">
                      <div className="p-w-100 ">
                        <div className="custom-inputs e-order-mng order">
                          <p className="text p-mb-1">Rate (Incl. of GST)</p>
                          {readOnly ? (
                            <p className="sub-text">{item.rateIncludingGST}</p>
                          ) : (
                            <>
                              <div>
                                <InputText
                                  value={item.rateIncludingGST}
                                  onChange={(e) =>
                                    handleItemListChange(
                                      e.target.value,
                                      "rateIncludingGST",
                                      vIdx,
                                      /^\d+(\.\d{0,2})?$/i
                                    )
                                  }
                                  maxLength={15}
                                  placeholder="Rate"
                                  className="p-w-100 e-input-common"
                                />
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </>
                ) : null}
                <div className="p-sm-12 p-md-3">
                  <div className="p-w-100 ">
                    <div className="custom-inputs e-order-mng order">
                      <p className="text p-mb-1">Quantity</p>
                      {readOnly ? (
                        <p className="sub-text">{item.quantity}</p>
                      ) : (
                        <>
                          <div>
                            <InputText
                              value={item.quantity}
                              onChange={(e) =>
                                handleItemListChange(
                                  e.target.value,
                                  "quantity",
                                  vIdx,
                                  /^\d+(\.\d{0,2})?$/i
                                )
                              }
                              maxLength={10}
                              placeholder="Quantity"
                              className="p-w-100 e-input-common"
                            />
                          </div>
                          <span className="error-msg" style={{ color: "red" }}>
                            {item.quantityErr ? item.quantityErrText : null}{" "}
                          </span>
                        </>
                      )}
                    </div>
                  </div>
                </div>
                <div className="p-sm-12 p-md-3">
                  <div className="p-w-100 ">
                    <div className="custom-inputs e-order-mng order">
                      <p className="text p-mb-1">Unit</p>
                      {readOnly ? (
                        <p className="sub-text">{item.unitName}</p>
                      ) : (
                        <>
                          <div>
                            <Dropdown
                              filter
                              options={dropdownData.units}
                              value={item.unit}
                              onChange={(e) =>
                                handleItemListChange(e.value, "unit", vIdx)
                              }
                              placeholder="Unit"
                              className="p-w-100 e-input-common"
                            />
                          </div>
                          <span className="error-msg" style={{ color: "red" }}>
                            {item.unitErr ? item.unitErrText : null}{" "}
                          </span>
                        </>
                      )}
                    </div>
                  </div>
                </div>
                {formData.isGst ? (
                  <div className="p-sm-12 p-md-3">
                    <div className="p-w-100 ">
                      <div className="custom-inputs e-order-mng order">
                        <p className="text p-mb-1">Total Amount (Incl. GST)</p>
                        {readOnly ? (
                          <p className="sub-text">
                            {item.totalAmountIncludingGST}
                          </p>
                        ) : (
                          <>
                            <div>
                              <InputText
                                value={item.totalAmountIncludingGST}
                                onChange={(e) =>
                                  handleItemListChange(
                                    e.target.value,
                                    "totalAmountIncludingGST",
                                    vIdx,
                                    /^\d+(\.\d{0,2})?$/i
                                  )
                                }
                                maxLength={15}
                                placeholder="Amount"
                                className="p-w-100 e-input-common"
                              />
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                ) : null}
                {formData.isBatch ? (
                  <div className="p-sm-12 p-md-3">
                    <div className="p-w-100 ">
                      <div className="custom-inputs e-order-mng order">
                        <p className="text p-mb-1">Batch No</p>
                        {readOnly ? (
                          <p className="sub-text">{item.batchNoName}</p>
                        ) : (
                          <>
                            <div>
                              <Dropdown
                                filter
                                options={batchesList[item.itemId] || []}
                                value={item.batchNo}
                                onChange={(e) =>
                                  handleItemListChange(e.value, "batchNo", vIdx)
                                }
                                placeholder="Batch No"
                                className="p-w-100 e-input-common"
                              />
                            </div>
                            <span
                              className="error-msg"
                              style={{ color: "red" }}
                            >
                              {item.batchNoErr ? item.batchNoErrText : null}
                            </span>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                ) : null}
                <div className="p-sm-12 p-md-3">
                  <div className="p-w-100 ">
                    <div className="custom-inputs e-order-mng order">
                      <p className="text p-mb-1">From Warehouse</p>
                      {readOnly ? (
                        <p className="sub-text">{item.fromWarehouseName}</p>
                      ) : (
                        <>
                          <div>
                            <Dropdown
                              filter
                              options={dropdownData.warehouse}
                              value={item.fromWarehouse}
                              onChange={(e) =>
                                handleItemListChange(
                                  e.value,
                                  "fromWarehouse",
                                  vIdx
                                )
                              }
                              placeholder="Warehouse"
                              className="p-w-100 e-input-common"
                            />
                          </div>
                          <span className="error-msg" style={{ color: "red" }}>
                            {item.fromWarehouseErr
                              ? item.fromWarehouseErrText
                              : null}
                          </span>
                        </>
                      )}
                    </div>
                  </div>
                </div>
                <div className="p-sm-12 p-md-3">
                  <div className="p-w-100 ">
                    <div className="custom-inputs e-order-mng order">
                      <p className="text p-mb-1">Current Quantity</p>
                      {readOnly ? (
                        <p className="sub-text">{item.currentQuantity}</p>
                      ) : (
                        <InputText
                          value={item.currentQuantity}
                          onChange={(e) =>
                            handleItemListChange(
                              e.target.value,
                              "currentQuantity",
                              vIdx,
                              /^\d+(\.\d{0,2})?$/i
                            )
                          }
                          maxLength={10}
                          placeholder="Current Quantity"
                          className="p-w-100 e-input-common"
                        />
                      )}
                    </div>
                  </div>
                </div>
                {formData.isBatch ? (
                  <>
                    <div className="p-sm-12 p-md-3">
                      <div className="p-w-100 ">
                        <div className="custom-inputs e-order-mng order">
                          <p className="text p-mb-1">MFG Date </p>
                          {readOnly ? (
                            <p className="sub-text">
                              {item.mfgDate
                                ? moment(item.mfgDate).format("DD/MM/YYYY")
                                : ""}
                            </p>
                          ) : (
                            <>
                              <div>
                                <Calendar
                                  value={
                                    item.mfgDate ? new Date(item.mfgDate) : null
                                  }
                                  onChange={(e) =>
                                    handleItemListChange(
                                      e.value,
                                      "mfgDate",
                                      vIdx
                                    )
                                  }
                                  dateFormat="dd/mm/yy"
                                  showIcon={false}
                                  placeholder="Select MFG Date"
                                  className="p-w-100"
                                  disabled={readOnly}
                                />
                              </div>
                              <span
                                className="error-msg"
                                style={{ color: "red" }}
                              >
                                {item.mfgDateErr ? item.mfgDateErrText : null}
                              </span>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="p-sm-12 p-md-3">
                      <div className="p-w-100 ">
                        <div className="custom-inputs e-order-mng order">
                          <p className="text p-mb-1">Lifespan</p>
                          {readOnly ? (
                            <p className="sub-text">{item.lifeSpan}</p>
                          ) : (
                            <>
                              <div>
                                <InputText
                                  value={item.lifeSpan}
                                  onChange={(e) =>
                                    handleItemListChange(
                                      e.target.value,
                                      "lifeSpan",
                                      vIdx,
                                      /^\d*$/i
                                    )
                                  }
                                  maxLength={10}
                                  placeholder="Life Span"
                                  className="p-w-100 e-input-common"
                                />
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="p-sm-12 p-md-3">
                      <div className="p-w-100 ">
                        <div className="custom-inputs e-order-mng order">
                          <p className="text p-mb-1">Expiry Date</p>
                          {readOnly ? (
                            <p className="sub-text">
                              {item.expiryDate
                                ? moment(item.expiryDate).format("DD/MM/YYYY")
                                : ""}
                            </p>
                          ) : (
                            <Calendar
                              value={
                                item.expiryDate
                                  ? new Date(item.expiryDate)
                                  : null
                              }
                              onChange={(e) =>
                                handleItemListChange(
                                  e.value,
                                  "expiryDate",
                                  vIdx
                                )
                              }
                              dateFormat="dd/mm/yy"
                              showIcon={false}
                              placeholder="Select Expiry Date"
                              className="p-w-100"
                              disabled={readOnly}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </>
                ) : null}

                <div className="p-sm-12 p-md-3">
                  <div className="p-w-100 ">
                    <div className="custom-inputs e-order-mng order">
                      <p className="text p-mb-1">MRP</p>
                      {readOnly ? (
                        <p className="sub-text">{item.mrp}</p>
                      ) : (
                        <InputText
                          value={item.mrp}
                          onChange={(e) =>
                            handleItemListChange(
                              e.target.value,
                              "mrp",
                              vIdx,
                              /^\d*$/i
                            )
                          }
                          maxLength={10}
                          placeholder="MRP"
                          className="p-w-100 e-input-common"
                        />
                      )}
                    </div>
                  </div>
                </div>

                <div className="p-sm-12 p-md-3">
                  <div className="p-w-100 ">
                    <div className="custom-inputs e-order-mng order">
                      <p className="text p-mb-1">
                        {formData.isGst
                          ? "Total Amount (Excl. GST)"
                          : "Total Amt"}
                      </p>
                      {readOnly ? (
                        <p className="sub-text">{item.amount}</p>
                      ) : (
                        <InputText
                          disabled
                          value={
                            Number(item?.rateExcludingGST) *
                            Number(item?.quantity)
                          }
                          onChange={(e) =>
                            handleItemListChange(e.target.value, "amount", vIdx)
                          }
                          maxLength={10}
                          placeholder="Amount"
                          className="p-w-100 e-input-common"
                        />
                      )}
                    </div>
                  </div>
                </div>
                <div className="p-sm-12 p-md-3">
                  <div className="p-w-100 ">
                    <div className="custom-inputs e-order-mng order">
                      <p className="text p-mb-1">Total MRP</p>
                      {readOnly ? (
                        <p className="sub-text">
                          {itemList?.length
                            ? itemList?.reduce(
                                (a, b) => Number(a) + Number(b.mrp),
                                0
                              ) *
                              itemList?.reduce(
                                (a, b) => Number(a) + Number(b.quantity),
                                0
                              )
                            : 0.0}
                        </p>
                      ) : (
                        <InputText
                          disabled
                          className="p-w-100"
                          value={
                            itemList?.length
                              ? itemList?.reduce(
                                  (a, b) => Number(a) + Number(b.mrp),
                                  0
                                ) *
                                itemList?.reduce(
                                  (a, b) => Number(a) + Number(b.quantity),
                                  0
                                )
                              : 0.0
                          }
                          onChange={(e) =>
                            handleFormChange(e.target.value, "totalMRP")
                          }
                          maxLength={200}
                          placeholder="Total MRP"
                        />
                      )}
                    </div>
                  </div>
                </div>
                <div className="p-sm-12">
                  <div className="p-w-100 ">
                    <div className="custom-inputs e-order-mng order">
                      <p className="text p-mb-1">Remarks</p>
                      {readOnly ? (
                        <p className="sub-text">{item.remarks}</p>
                      ) : (
                        <InputTextarea
                          className="p-w-100"
                          value={item.remarks}
                          onChange={(e) =>
                            handleItemListChange(
                              e.target.value,
                              "remarks",
                              vIdx
                            )
                          }
                          maxLength={200}
                          placeholder="Remarks"
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
          {!readOnly && (
            <Button
              variant="outlined"
              color="primary"
              onClick={addItem}
              className="add-item-btn"
            >
              <i className="pi pi-plus" style={{ marginRight: 8 }}></i> Add Item
            </Button>
          )}
        </div>
      </div>
      <div className="p-d-flex p-ai-center p-jc-start e-inward-footer">
        <button
          className="secondary-btn"
          onClick={() => {
            props.history.push("/admin/outward");
          }}
        >
          Cancel
        </button>
        {/* {readOnly ? null : (
          <Button
            className="e-add-btn color-white p-ml-1"
            onClick={() => AddOutward("Performa Invoice")}
            // disabled={loading}
          >
            Performa Invoice
          </Button>
        )} */}
        {readOnly ? null : (
          <Button
            className="primary-btn color-white p-ml-1"
            onClick={() => AddOutward("Tax Invoice")}
            disabled={loading}
          >
            {loading ? "Submitting" : "Tax Invoice"}
          </Button>
        )}
      </div>
    </>
  );
};

export default SellOutward;
